<template>
  <div></div>
</template>

<script>
export default {
  name: "OidcRenew",
  beforeMount() {
    this.$authService
      .getUserManager()
      .signinSilentCallback()
      .catch(function (err) {
        this.$store.commit("resetUser");
        console.log(err);
      });
  },
};
</script>